import api from './api';

export const crewService = {
  getAll: (activeOnly = false) =>
    api.get(`/crews/${activeOnly ? '?active_only=true' : ''}`),
  getById: (id) => api.get(`/crews/${id}`),
  create: (crewData) => api.post('/crews/', crewData),
  update: (id, crewData) => api.put(`/crews/${id}`, crewData),
  delete: (id) => api.delete(`/crews/${id}`),
};
